<div class="pii-table-container">
  <!-- Table Header Actions -->
  <div class="pii-table-header mb-3" *ngIf="showActions && processedRows.length > 0">
    <div class="d-flex justify-content-between align-items-center">
      <div class="pii-stats">
        <small class="text-muted">
          <i appFeatherIcon data-feather="database"></i>
          Total Records: {{ processedRows.length }} | 
          <span *ngIf="unmaskedRowsCount > 0" class="text-warning">
            <i appFeatherIcon data-feather="eye"></i>
            Unmasked: {{ unmaskedRowsCount }}
          </span>
        </small>
      </div>
      
      <div class="pii-actions">
        <button 
          *ngIf="unmaskedRowsCount > 0"
          type="button" 
          class="btn btn-sm btn-outline-secondary"
          (click)="maskAllRows()"
          title="Mask All Rows">
          <i appFeatherIcon data-feather="eye-off"></i>
          Mask All
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading PII data...</p>
  </div>

  <!-- Table -->
  <div *ngIf="!loading" class="table-responsive">
    <table [class]="tableClass">
      <!-- Table Header -->
      <thead class="table-dark">
        <tr>
          <th *ngFor="let column of columns" [style.width]="column.width">
            {{ column.label }}
            <i *ngIf="column.isPii" appFeatherIcon data-feather="shield" class="ms-1 text-warning" title="PII Field"></i>
          </th>
          <th *ngIf="showActions" class="text-center" style="width: 150px;">
            <i appFeatherIcon data-feather="settings"></i>
            Actions
          </th>
        </tr>
      </thead>

      <!-- Table Body -->
      <tbody>
        <!-- No Data State -->
        <tr *ngIf="processedRows.length === 0">
          <td [attr.colspan]="columns.length + (showActions ? 1 : 0)" class="text-center py-4 text-muted">
            <i appFeatherIcon data-feather="inbox" class="mb-2"></i>
            <br>
            No data available
          </td>
        </tr>

        <!-- Data Rows -->
        <tr *ngFor="let row of processedRows; let i = index" 
            [class.table-warning]="row.isUnmasked"
            [class.pii-row-unmasked]="row.isUnmasked">
          
          <!-- Data Cells -->
          <td *ngFor="let column of columns" 
              [class.pii-cell]="column.isPii"
              [class.pii-masked]="column.isPii && !row.isUnmasked"
              [class.pii-unmasked]="column.isPii && row.isUnmasked">
            
            <div class="cell-content">
              <span class="cell-value">{{ getCellValue(row, column.key) }}</span>
              
              <!-- PII Indicator -->
              <span *ngIf="column.isPii && !row.isUnmasked" class="pii-indicator ms-2">
                <i appFeatherIcon data-feather="eye-off" class="text-muted" title="Masked PII"></i>
              </span>
              
              <span *ngIf="column.isPii && row.isUnmasked" class="pii-indicator ms-2">
                <i appFeatherIcon data-feather="eye" class="text-warning" title="Unmasked PII"></i>
              </span>
            </div>
          </td>

          <!-- Action Buttons -->
          <td *ngIf="showActions" class="text-center">
            <div class="btn-group btn-group-sm" role="group">
              <!-- Unmask Button -->
              <button 
                *ngIf="!row.isUnmasked && hasRowPiiData(row)" 
                type="button" 
                class="btn btn-outline-primary"
                (click)="onUnmaskRow(i)"
                [disabled]="row.isLoading"
                title="Unmask PII Data">
                <i appFeatherIcon data-feather="eye" *ngIf="!row.isLoading"></i>
                <span *ngIf="row.isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
              
              <!-- Mask Button -->
              <button 
                *ngIf="row.isUnmasked" 
                type="button" 
                class="btn btn-outline-secondary"
                (click)="onMaskRow(i)"
                title="Mask PII Data">
                <i appFeatherIcon data-feather="eye-off"></i>
              </button>
              
              <!-- Copy Button -->
              <button 
                *ngIf="row.isUnmasked" 
                type="button" 
                class="btn btn-outline-info"
                (click)="onCopyRow(i)"
                title="Copy PII Data">
                <i appFeatherIcon data-feather="copy"></i>
              </button>
            </div>
            
            <!-- No PII Indicator -->
            <span *ngIf="!hasRowPiiData(row)" class="text-muted small">
              <i appFeatherIcon data-feather="minus"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Security Notice -->
  <div class="pii-security-notice mt-3" *ngIf="unmaskedRowsCount > 0">
    <div class="alert alert-warning alert-sm">
      <i appFeatherIcon data-feather="shield" class="me-2"></i>
      <strong>Security Notice:</strong> 
      {{ unmaskedRowsCount }} row(s) with unmasked PII data. All access has been logged for audit purposes.
    </div>
  </div>
</div> 